document.addEventListener('DOMContentLoaded', function () {
    const tabsWrapper = document.querySelector('.tabs-wrapper');
    if (!tabsWrapper) return;

    const tabs = tabsWrapper.querySelectorAll('.tab');

    let tabIndicator = tabsWrapper.querySelector('.tab-indicator');
    if (!tabIndicator) {
        tabIndicator = document.createElement('div');
        tabIndicator.className = 'tab-indicator';
        tabsWrapper.appendChild(tabIndicator);
    }

    function moveIndicator(tab) {
        const wrapperRect = tabsWrapper.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();

        const tabLeftRelative = tabRect.left - wrapperRect.left;

        const tabWidth = tab.offsetWidth;
        const indicatorWidth = Math.max(tabWidth, 143);

        tabIndicator.style.width = indicatorWidth + 'px';

        const leftOffset = tabLeftRelative + (tabWidth / 2) - (indicatorWidth / 2);
        tabIndicator.style.left = leftOffset + 'px';
    }

    function toggleProductWrappers(activeTabValue) {
        const wrappers = document.querySelectorAll('.flexible-products-tabs-section .flexible-products-wrapper');
        wrappers.forEach(wrapper => {
            if (wrapper.dataset.tab === activeTabValue) {
                wrapper.classList.add('active');
            } else {
                wrapper.classList.remove('active');
            }
        });
    }

    function setActiveTab(tab) {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        moveIndicator(tab);

        const tabValue = tab.getAttribute('data-tab');
        toggleProductWrappers(tabValue);
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', () => setActiveTab(tab));
    });

    const initialActiveTab = tabsWrapper.querySelector('.tab.active');
    if (initialActiveTab) {
        moveIndicator(initialActiveTab);
    } else if (tabs.length) {
        setActiveTab(tabs[0]);
    }

    window.addEventListener('resize', () => {
        const activeTab = tabsWrapper.querySelector('.tab.active');
        if (activeTab) {
            moveIndicator(activeTab);
        }
    });
});
